/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const iconHeight = 20;
const iconMarginRight = 4;

const useContextWarningsStyles = makeStyles<Theme, { indent: number }>(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    minWidth: ({ indent }) => `${(iconHeight + iconMarginRight) * indent}px`,
  },
  justifyCenter: {
    justifyContent: 'center',
  },
  justifyEnd: {
    justifyContent: 'flex-end',
  },
  justifyStart: {
    justifyContent: 'flex-start',
  },
  checkboxWarnings: {
    marginTop: '1px',
  },
  textFieldWarnings: {
    marginTop: '13px',
  },
  warn: {
    color: theme.palette.warning.main,
    height: `${iconHeight}px`,
    marginRight: `${iconMarginRight}px`,
  },
  warnIcon: {
    width: 'auto',
    height: '100%',
  },
}));

export { useContextWarningsStyles };
